import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1>About StoryBuddy</h1>
        <p className="about-tagline">
          AI-powered stories crafted for your child's age, interests, and learning journey.
        </p>
      </section>

      <section className="about-section">
        <h2>Our Mission</h2>
        <p>
          StoryBuddy was created to make storytelling personal, educational, and fun.
          Every child deserves stories that reflect who they are — their name, their
          interests, and their stage of learning. We use AI to generate unique, age-appropriate
          stories with custom illustrations, turning screen time into meaningful learning time.
        </p>
      </section>

      <section className="about-section">
        <h2>What We Offer</h2>
        <div className="about-features">
          <div className="about-feature">
            <span className="about-feature-icon">&#9997;&#65039;</span>
            <h3>Personalized Stories</h3>
            <p>Stories tailored to your child's name, age, and interests.</p>
          </div>
          <div className="about-feature">
            <span className="about-feature-icon">&#127912;</span>
            <h3>AI Illustrations</h3>
            <p>Custom cartoon avatars and visuals generated for each story.</p>
          </div>
          <div className="about-feature">
            <span className="about-feature-icon">&#128218;</span>
            <h3>Learning Map</h3>
            <p>An interactive knowledge graph that tracks what your child learns through stories.</p>
          </div>
          <div className="about-feature">
            <span className="about-feature-icon">&#127891;</span>
            <h3>Quizzes</h3>
            <p>Fun quizzes after each story to reinforce comprehension.</p>
          </div>
        </div>
      </section>

      <section className="about-section about-contact">
        <h2>About the Creator</h2>
        <p>
          This website is designed by <strong>Prof. Sumeet Kumar</strong> at the{" "}
          <strong>Indian School of Business</strong>. For any suggestions, please write to:
        </p>
        <img
          src="/email-contact.png"
          alt="Contact email"
          className="about-email-img"
          draggable="false"
        />
      </section>

      <div className="about-back">
        <Link to="/" className="about-back-link">&larr; Back to Home</Link>
      </div>
    </div>
  );
};

export default About;
